import { destroy, get, post } from '../../../../../api/axios';
import { AccountEndpoints } from '../../../../../api/endpoints/AccountEndpoints';
import { type AccountDetailsDto } from '../../../../models/AccountDetailsDto';
import { type ContactDto } from '../../../../models/Contact';
import { type EnumType } from '../../../../models/EnumType';
import { type UserChangeEmailRequestDto } from '../../../../models/UserChangeEmailRequestDto';
import { type UserChangePasswordRequestDto } from '../../../../models/UserChangePasswordRequestDto';

export const linkGoogleAccount = (token: string) => {
  return post<ContactDto>(AccountEndpoints.linkGoogleAccount, { token: token });
};

export const unlinkGoogleAccount = () => {
  return destroy<ContactDto>(AccountEndpoints.unlinkGoogleAccount);
};

export const saveUserPreferences = (userPreferences: AccountDetailsDto) => {
  return post<AccountDetailsDto>(AccountEndpoints.save, userPreferences);
};

export const changeUserPassword = (request: UserChangePasswordRequestDto) => {
  return post(AccountEndpoints.changePassword, request);
};

export const changeUserEmail = (email: UserChangeEmailRequestDto) => {
  return post(AccountEndpoints.changeEmail, email);
};

export const saveDisabledNotifications = (disabledNotifications: EnumType[]) => {
  return post<EnumType[]>(AccountEndpoints.notificationsPreferencesDisabledSave, disabledNotifications);
};

export const getUserPreferencesDetails = () => {
  return get<AccountDetailsDto>(AccountEndpoints.details);
};

export const getNotificationsAvailableList = () => {
  return get<EnumType[]>(AccountEndpoints.notificationsPreferencesAvailableList);
};

export const getNotificationsDisabledList = () => {
  return get<EnumType[]>(AccountEndpoints.notificationsPreferencesDisabledList);
};
